<template>
  <div>
    <v-layout row wrap justify-end pt-3 pl-0>
        <v-menu
            :disabled="disabled || readonly"
            v-model="menuStart"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
            >
            <template v-slot:activator="{ on }">
                <v-text-field outlined dense
                v-model="computedStartDateFormatted"
                :label="plabel"
                hint="DD-MM-YYYY"
                persistent-hint
                prepend-inner-icon="mdi-calendar"
                :disabled="disabled"
                readonly
                v-on="on"
                :rules="rules"
                ></v-text-field>
            </template>
            <v-date-picker v-bind:value="value ? value : tempDate" no-title v-on:change="onChangeDate"></v-date-picker>
        </v-menu>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment'
import configs from "@/configs"

export default {
    props: {
        value: String,
        plabel: String,
        rules: Array,
        disabled: Boolean,
        readonly: Boolean,
    },
    data() {
        return {
            menuStart: false,
            tempDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
        };
    },
    computed: {
        computedStartDateFormatted () {
            return this.value ? moment(this.value).format(configs.SHORT_DATE_FORMAT) : '';
        }
    },
    methods: {
        onChangeDate(val) {
            this.$emit('onChangeDate', val);
            this.menuStart = false;
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
    }
}
</script>